import { env } from 'helpers/parameters'

export const IS_DEBUG = env.stage === 'dev'

export const API_OPERATIONS = {
  QUERY: 'query',
  RETRIEVE: 'retrieve',
  LIST_INDICES: 'listIndices',
  DESCRIBE_INDEX: 'describeIndex',
  LIST_DATA_SOURCES: 'listDataSources',
  GET_QUERY_SUGGESTIONS: 'getQuerySuggestions',
  SUBMIT_FEEDBACK: 'submitFeedback',
  DESCRIBE_QUERY_SUGGESTIONS_CONFIG: 'describeQuerySuggestionsConfig'
}

export const PAGE_SIZE = 10

// show a max of 7 pages centered at the current page
export const PAGINATION_CONFIG = {
  PREVIOUS_PAGES: 3,
  NEXT_PAGES: 4,
  MAX_VISIBLE_PAGES: 7
}

export const CHARACTER_WIDTH = 13

export const COLLAPSED_LINES = 2

export const FAQ_MATCHES = 'Kendra found questions like yours'

export const QUERY_RESULT_TYPE = {
  ALL: 'ALL',
  ANSWER: 'ANSWER',
  QUESTION_ANSWER: 'QUESTION_ANSWER',
  DOCUMENT: 'DOCUMENT'
}

export const DOCUMENT_ATTRIBUTE_KEYS = {
  CATEGORY: '_category',
  CREATED_AT: '_created_at',
  DATA_SOURCE_ID: '_data_source_id',
  DOCUMENT_TITLE: '_document_title',
  FORMAT: '_file_type',
  SOURCE_URI: '_source_uri',
  UPDATED_AT: '_last_updated_at',
  VERSION: '_version',
  VIEW_COUNT: '_view_count'
}

export const DOCUMENT_ATTRIBUTE_TITLE_LOOKUP = {
  [DOCUMENT_ATTRIBUTE_KEYS.CATEGORY]: 'Category',
  [DOCUMENT_ATTRIBUTE_KEYS.CREATED_AT]: 'Created at',
  [DOCUMENT_ATTRIBUTE_KEYS.DATA_SOURCE_ID]: 'Data source',
  [DOCUMENT_ATTRIBUTE_KEYS.DOCUMENT_TITLE]: 'Title',
  [DOCUMENT_ATTRIBUTE_KEYS.FORMAT]: 'File type',
  [DOCUMENT_ATTRIBUTE_KEYS.SOURCE_URI]: 'Source URI',
  [DOCUMENT_ATTRIBUTE_KEYS.UPDATED_AT]: 'Updated at',
  [DOCUMENT_ATTRIBUTE_KEYS.VERSION]: 'Version',
  [DOCUMENT_ATTRIBUTE_KEYS.VIEW_COUNT]: 'View count'
}

export const ADDITIONAL_RESULT_ATTRIBUTE_KEYS = {
  QUESTION_TEXT: 'QuestionText',
  ANSWER_TEXT: 'AnswerText'
}

export const FEEDBACK = {
  RELEVANT: 'RELEVANT',
  NOT_RELEVANT: 'NOT_RELEVANT',
  CLICK: 'CLICK'
}

export const DOCUMENT_ATTRIBUTE_VALUE_TYPE = {
  DATE_VALUE: 'DATE_VALUE',
  LONG_VALUE: 'LONG_VALUE',
  STRING_LIST_VALUE: 'STRING_LIST_VALUE',
  STRING_VALUE: 'STRING_VALUE'
}

export const QUERY_SUGGESTIONS_MODE = {
  ENABLED: 'ENABLED',
  LEARN_ONLY: 'LEARN_ONLY'
}

export const DEFAULT_SORT_ATTRIBUTE = 'Relevance'

export const SORT_ORDER = {
  DESC: 'DESC',
  ASC: 'ASC'
}

export const SORT_TEXT = {
  SORT: 'Sort:'
}

export const FACET_ACTION_TEXT = {
  SHOW_MORE: 'Show more...',
  SHOW_LESS: 'Show less...',
  CLEAR: 'Clear',
  FILTER_SEARCH_RESULTS: 'Filter search results',
  RESET_FILTERS: 'Reset filters'
}

export const SEARCH_QUERY_VALIDITY_IN_HOURS = 24